<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New FAQ</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                  label="Kategori"
                  :options="newOptionsCategory"
                  required
                  horizontal
                  v-model="faqData.category"
                  @change="handleCategory"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                  label="Topic"
                  :options="getOptionsTopic"
                  required
                  horizontal
                  v-model="faqData.topic"
                  placeholder="Select Data"
                  @change="handleTopic"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  label="Sub Topic"
                  class="mb-0"
                  required
                  horizontal
                  placeholder="Sub Topic"
                  @change="handleSubTopic"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  label="Pertanyaan"
                  class="mb-0"
                  horizontal
                  placeholder="Pertanyaan"
                  @change="handleQuestion"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                  type="number"
                  min="0"
                  max="1000"
                  label="Priority"
                  class="mb-0"
                  horizontal
                  placeholder="Priority to show on Website"
                  v-model="faqData.priority"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CTextarea
                id="meta_description"
                label="Meta Description"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Description"
                v-model="faqData.meta_info_description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CTextarea
                id="meta_description"
                label="Meta Keyword"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Keyword"
                v-model="faqData.meta_info_keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Language"
                :options="newOptionsLang"
                required
                horizontal
                v-model="faqData.lang"
                @change="handleLang"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Country"
                :options="newOptionsCountry"
                data-testid="cms-faq-create-country"
                required
                horizontal
                v-model="faqData.country"
                @change="handleCountry"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="12">
              <a>Jawaban</a>
              <editor
                id="editor"
                :api-key="key"
                :init="initOption"
                v-model="content"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                  color="success"
                  class="float-right"
                  :disabled="disableButton"
                  @click="createFaq()"
              >Create
              </CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import FAQUseCase from "./app/usecase";
import FAQEnum from "./app/constants/options"
import Editor from "@tinymce/tinymce-vue";
import jwt from "jsonwebtoken";
import initTinymce from "@/app/constants/initTinymce";

export default {
  name: "FaqCreate",
  components: { editor: Editor },
  computed: {
    getOptionsTopic() {
      if (this.faqData.category === "BANTUAN") {
        return this.newOptionsHelp
      }
      return this.newOptionsApps
    },
  },
  data() {
    return {
      faqData: {
        topic: "",
        sub_topic: "",
        question: "",
        answer: "",
        status: "ACTIVE",
        category: "BANTUAN",
        priority: 0,
        meta_info_description: '',
        meta_info_keyword: '',
        lang: 'ID',
        country: "indonesia"
      },
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      newOptionsHelp: FAQEnum.OPTION_TOPIC_HELP,
      newOptionsApps: FAQEnum.OPTION_TOPIC_APPS,
      newOptionsCategory: FAQEnum.OPTION_CATEGORY,
      newOptionsLang: FAQEnum.OPTION_LANG,
      newOptionsCountry: FAQEnum.OPTION_COUNTRY,
      content: "",
      disableButton: false,
      initOption: initTinymce.init,
      key: initTinymce.key,
    };
  },
  mounted() {
    this.authentication();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "NPOS" ||
          data.account_group === "QC" ||
          data.account_group === "COMMUNITY" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null
      } else {
        this.$router.push({path: `/`});
      }
    },
    goBack() {
      this.usersOpened
          ? this.$router.go(-1)
          : this.$router.push({path: "/management/faq"});
    },
    handleCategory(event) {
      this.faqData.topic = ""
      this.faqData.category = event.target.value;
    },
    handleTopic(event) {
      this.faqData.topic = event.target.value;
    },
    handleSubTopic(event) {
      this.faqData.sub_topic = event;
    },
    handleQuestion(event) {
      this.faqData.question = event;
    },
    handleLang(event) {
      this.faqData.lang = event.target.value;
    },
    handleCountry(event) {
      this.faqData.country = event.target.value;
    },
    async createFaq() {
      this.disableButton = true;
      this.faqData.answer = this.content;
      if (this.faqData.priority && +this.faqData.priority > 0) {
        this.faqData.priority = +this.faqData.priority
      }
      if (typeof this.faqData.priority === "string" && (this.faqData.priority === "" || this.faqData.priority === "0")) {
        this.faqData.priority = null
      }
      try {
        const resp = await FAQUseCase.createOne(this.faqData)
        if (!resp.err) {
          let msg = "FAQ Created"
          if (resp.message !== "") {
            msg += ", " + resp.message
          }
          await this.$swal.fire({
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 2000
          })
          await this.$router.push({path: `/management/faq`})
        } else {
          await this.$swal.fire({
            icon: "warning",
            title: "Oops...",
            text: resp.err
          })
        }
        this.disableButton = false;
      } catch (err) {
        this.disableButton = false;
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.err || "something went wrong"
        })
      }
    },
  }
};
</script>

<style scoped>
@import "./Faq.css";
</style>
